import { IS_ACTIVE } from "../_defs";
import { getElement } from "../functions/_getElement";
import { getElements } from "../functions/_getElements";

const DELTA = 0.1;

export class MouseStalker {
  readonly element: HTMLElement | null;
  #paused: boolean;
  #x: number;
  #y: number;
  #targetX: number;
  #targetY: number;
  #listener: (ev: MouseEvent) => void;

  constructor(e: string | HTMLElement | null | undefined, debug = false) {
    this.element = getElement(e);
    this.#paused = false;
    this.#x = NaN;
    this.#y = NaN;
    this.#targetX = NaN;
    this.#targetY = NaN;
    this.#listener = (ev) => {
      this.update(ev.pageX, ev.pageY);
    };
    window.addEventListener("mousemove", this.#listener);

    if (this.element && debug) {
      window.addEventListener("click", (ev) => {
        this.#paused = !this.#paused;
        ev.preventDefault();
        ev.stopPropagation();
      });
    }
  }

  activateBy(e: string | HTMLElement | null | undefined): void {
    getElements(e).forEach((x) => {
      x.addEventListener("mouseenter", () => {
        if (this.#paused) return;
        this.element?.classList.add(IS_ACTIVE);
      });
      x.addEventListener("mouseleave", () => {
        if (this.#paused) return;
        this.element?.classList.remove(IS_ACTIVE);
      });
    });
  }

  updateClassBy(
    e: string | HTMLElement | null | undefined,
    className: string
  ): void {
    getElements(e).forEach((x) => {
      x.addEventListener("mouseenter", () => {
        if (this.#paused) return;
        this.element?.classList.add(className);
      });
      x.addEventListener("mouseleave", () => {
        if (this.#paused) return;
        this.element?.classList.remove(className);
      });
    });
  }

  update(x: number, y: number): void {
    if (this.element === null || this.#paused) return;

    this.#targetX = x;
    this.#targetY = y - document.documentElement.scrollTop;
    this.run();
  }

  private run(): void {
    if (this.element === null) return;

    window.requestAnimationFrame(() => this.updatePosition());
  }

  private updatePosition(): void {
    if (this.element === null) return;

    if (!Number.isFinite(this.#targetX) || !Number.isFinite(this.#targetY)) {
      return;
    }

    if (!Number.isFinite(this.#x) || !Number.isFinite(this.#y)) {
      this.#x = this.#targetX;
      this.#y = this.#targetY;

      return;
    }

    const dx = this.#x - this.#targetX;
    const dy = this.#y - this.#targetY;

    if (-DELTA < dx && dx < DELTA && -DELTA < dy && dy < DELTA) return;

    const radian = Math.atan2(this.#y - this.#targetY, this.#x - this.#targetX);
    const distance = Math.sqrt(dx * dx + dy * dy);

    this.#x -= (Math.cos(radian) / 500) * distance;
    this.#y -= (Math.sin(radian) / 500) * distance;

    this.element.style.left = `${this.#x}px`;
    this.element.style.top = `${this.#y}px`;

    this.run();
  }
}
